import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs/Rx';
import {Helper} from '../../common/helper';
declare const $: any;

const MAX_SIZE = 5 * 1024 * 1024;

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss'],
  preserveWhitespaces: false
})
export class ImageCropperComponent implements OnInit {
  @Input('imageCropperOptions') imageCropperOptions: any = {
    id: null
  };
  @Output() flagImgUpload = new EventEmitter<any>();
  @Output() flagImgDestroy = new EventEmitter<any>();
  public imagePath: string;
  public dammyImagePath: { [key: string]: string; } = {};
  public btnsDisabledFlag: boolean;
  public originName: string;

  public windowURL: any = (<any>window).URL || (<any>window).webkitURL;
  public imgData: string;

  public mouseFlag = true;
  public noImage = '/assets/img/user.png';
  private getCroppedCanvasOption: any = {};

  constructor(private helper: Helper) { }

  ngOnInit() {

    this.dammyImagePath['default'] = '/assets/img/image-cropper-photo-en.png';
    this.dammyImagePath['over'] = '/assets/img/image-cropper-photo-over-en.png';

    this.imagePath = this.dammyImagePath.default;
    this.btnsDisabledFlag = true;
    this.getCroppedCanvasOption.fillColor = '#fff';
  }

  @Input('imageUrl')
  set value(imageUrl: string) {
    if (imageUrl && imageUrl !== '') {
      if ($('.image-cropper-picture').attr('src')) {
        this.loadImage(imageUrl, this.imageCropperOptions.id, true);
      }
    }
  }

  setOption() {
    const configImage: any = {
      center: true,
      highlight: true,
      dragMode: 'move',
      zoomOnWheel: false,
      autoCropArea: 1,
      crop: this.helper.debounce(this.cropend, 400)
    };
    configImage.cropBoxResizable = false;
    configImage.autoCrop = true;
    configImage.aspectRatio = 1;
    configImage.minCropBoxHeight = 120;
    configImage.minCropBoxWidth = 120;
    configImage.checkCrossOrigin = false;

    return configImage;
  }

  loadImage(imageUrl, id?, flag?) {
    if (imageUrl && id) {
      const $image = $('#' + id).find('.image-cropper-picture');
      if (flag) {
        $image.cropper('destroy');
        $image.attr('src', imageUrl);
        $image.cropper(this.setOption());
      } else {
        $image.cropper('replace', imageUrl);
        $image.cropper(this.setOption());
      }
      this.btnsDisabledFlag = null;
    }
  }

  errorLoadImage(event) {
    this.loadImage(this.noImage, this.imageCropperOptions.id, true);
  }

  cropend(e) {
    // emit event
    const id = $(e.target).parents('.image-cropper-inner-wrap');
    let event;
    event = document.createEvent('CustomEvent');
    event.initCustomEvent('imageChange', true, true, id);
    window.dispatchEvent(event);
  }

  getCropper(event: any) {
    const $cropper = $(event.target).parents('.image-cropper-inner-wrap');
    const $image = $cropper.find('.image-cropper-picture');
    const $file = $cropper.find('.image-cropper-upload');
    return {cropper: $cropper, image: $image, file: $file};
  }

  // on choose new image
  setCropper(obj: any) {
    obj.image.cropper(this.setOption());
  }

  onMouseClick(event: any) {
    const obj = this.getCropper(event);
    this.mouseFlag = false;
    obj.file.click();
  }

  onMouseOver() {
    if (this.btnsDisabledFlag && this.mouseFlag) {
      this.imagePath = this.dammyImagePath.over;
    }
  }

  onMouseOut() {
    if (this.btnsDisabledFlag && this.mouseFlag) {
      this.imagePath = this.dammyImagePath.default;
    }
  }

  imageUpload(event: any) {
    const obj = this.getCropper(event);
    const files = obj.file[0].files[0];
    this.originName = files.name;
    if (files.size > MAX_SIZE) {
      this.flagImgUpload.emit(false);
      return;
    } else {
      this.flagImgUpload.emit(true);
    }
    const reader: FileReader = new FileReader();
    const URL = (<any>window).URL || (<any>window).webkitURL;
    if (!(files.type && files.type.match(/^image\/(png|jpeg|gif)$/))) {
      return false;
    }
    if (URL) {
      const img = document.createElement('img');
      img.src = URL.createObjectURL(files);
      img.onload = () => {
        this.setCropper(obj);
        obj.image.cropper('replace', URL.createObjectURL(files));
        this.btnsDisabledFlag = null;
      };
      img.onerror = () => {
        return;
      };

    } else if (reader) {
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.setCropper(obj);
        obj.image.cropper('replace', reader.result);
        this.btnsDisabledFlag = null;
      };
    }
  }

  transformValue(e: any) {
    if (e === 'none') {
      return false;
    }
    let values = e.split('(')[1];
    values = values.split(')')[0];
    values = values.split(', ');
    const matrix = {
      'scale-x': values[0],
      'rotate-p': values[1],
      'rotate-m': values[2],
      'scale-y': values[3],
      'transform-x': values[4],
      'transform-y': values[5]
    };
    return matrix;
  }

  imageCropperAction(event: any, method: string, option: string) {
    const obj = this.getCropper(event);
    obj.image.cropper(method, option);
    if (method === 'destroy') {
      obj.file.val('');
      obj.image.attr('src', this.dammyImagePath.default);
      // this.setCropper(obj);
      this.cropend(event);
      this.btnsDisabledFlag = true;
    }
    if (method === 'round') {
      const _round = obj.cropper.find('.cropper-crop-box');
      const _width = _round.width() + Number(option);
      const _height = _round.height() + Number(option);
      const _matrix = this.transformValue(_round.css('transform'));
      const _left = Number(_matrix['transform-x']) - Number(option) / 2;
      const _top = (_matrix['transform-y']) ? Number(_matrix['transform-y']) - Number(option) / 2 : 0 - Number(option) / 2;
      obj.image.cropper('setCropBoxData', { left: _left, top: _top , width: _width, height: _height });
    }
  }

  imageRoundZoomIn(event: any) {
    this.imageCropperAction(event, 'round', '15');
  }

  imageRoundZoomOut(event: any) {
    this.imageCropperAction(event, 'round', '-15');
  }

  imageZoomIn(event: any) {
    this.imageCropperAction(event, 'zoom', '0.1');
  }

  imageZoomOut(event: any) {
    this.imageCropperAction(event, 'zoom', '-0.1');
  }

  imageRotateLeft(event: any) {
    this.imageCropperAction(event, 'rotate', '-15');
  }

  imageRotateRight(event: any) {
    this.imageCropperAction(event, 'rotate', '15');
  }

  imageDelete(event: any) {
    this.mouseFlag = true;
    this.flagImgUpload.emit(true);
    this.flagImgDestroy.emit(true);
    this.imageCropperAction(event, 'destroy', null);
  }

  getImageUrl(id: string): any {
    let imageObj;
    imageObj = $('#' + id).find('.image-cropper-picture');
    if (!id) {
      imageObj = $('.image-cropper-inner-wrap').find('.image-cropper-picture');
    }
    const src = imageObj.attr('src');
    const subject = new Subject();
    if (imageObj.length <= 0 || this.btnsDisabledFlag != null || !imageObj.data('cropper')) {
      subject.next();
      subject.error('no image');
    } else {
      imageObj.cropper('getCroppedCanvas', this.getCroppedCanvasOption)
        .toBlob((blob) => {
          if (this.imgData) {
            this.windowURL.revokeObjectURL(this.imgData);
          }
          blob.src = src;
          if (id) {
            blob.name = this.originName;
          }
          this.imgData = this.windowURL.createObjectURL(blob);
          subject.next(blob);
          subject.complete();
        }, 'image/jpeg');
    }
    return subject;
  }


}



// WEBPACK FOOTER //
// /app/src/app/components/image-cropper/image-cropper.component.ts